<!-- Migrado -->
<template>
  <el-collapse v-model="collapseModel">
    <elemento-header
      :title="title"
      :name="name"
    >
      <input-suaje
        v-model="localModel"
        :validate="validarSolicitudCampos"
        v-bind="componentsProps.InputSuaje"
        @update:unidadImposicion="onUnidadImposicionChange"
      />

      <input-procesos
        v-model="localModel.Secciones"
        :elemento-tipo="localModel.ElementoTipo"
      />
      <el-divider />
    </elemento-header>
  </el-collapse>
</template>

<script setup>
import {
  onBeforeMount,
  provide,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useElemento } from '@/shared/composables/useElemento.js';
import { useRequestStore } from '@/views/requests/stores/request_store.js';
import { useUnidadImposicionProvider } from '@/shared/composables/use_unidad_imposicion.js';
import InputProcesos from '@/shared/components/procesos/input_procesos.vue';
import InputSuaje from '@/shared/components/suaje/input_suaje.vue';
import { useComponentsProps } from '@/shared/composables/use_components_props.js';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';

const emit = defineEmits(['update:modelValue']);

const requestStore = useRequestStore();
const { validarSolicitudCampos } = storeToRefs(requestStore);
const { componentsProps } = useComponentsProps(ElementoBase.CAJA, Modules.SOLICITUD);

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, required: true },
  name: { type: String, required: true },
});

const { localModel, collapseModel, updateModelo } = useElemento(props, emit);

// Proveer valores de imposición para componentes de proceso
const imposicionProvidedValue = computed(() => ({
  EtiquetasEje: localModel.value.EtiquetasEje || 0,
  EtiquetasDesarrollo: localModel.value.EtiquetasDesarrollo || 0,
}));

provide('currentElementoBase', ElementoBase.CAJA);
provide('imposicion', imposicionProvidedValue);
const { onUnidadImposicionChange } = useUnidadImposicionProvider(localModel);

onBeforeMount(() => {
  updateModelo({
    EtiquetasEje: 1,
    EtiquetasDesarrollo: 1,
  });
});
</script>

<style scoped>
.detail-container-printed {
  padding: 0;
}
.custom-label {
  font-weight: 700;
  color: #111;
}

.colors-button {
  width: 100%;
}
</style>
